import { ReactElement } from 'react';
import { Box, Flex } from 'reflexbox';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';

import JourneyEmptyState from 'packages/kakapo-ui-kit/assets/illustrations/JourneyEmptyState';
import { SectionTitle } from 'packages/kakapo-ui-kit/components/common/Headings';

const EmptyStateWrapper = styled(Flex)`
	height: 300px;
`;

const StyledFlex = styled(Flex)`
	background-color: ${(props) => props.theme.colors.lightBlueLight};
`;

export default function JourneyListEmptyState(props: { isViewer: boolean }): ReactElement {
	const { t } = useTranslation();
	return (
		<EmptyStateWrapper
			flexGrow={1}
			mt={4}
			flexDirection="column"
			justifyContent="center"
			alignItems="start"
		>
			<StyledFlex
				px={6}
				pt={5}
				pb={4}
				flexDirection="column"
				justifyContent="center"
				alignItems="center"
			>
				<JourneyEmptyState />
				<Box mt={3}>
					<SectionTitle>
						{t(
							props.isViewer
								? 'journey.list.emptyState.title'
								: 'journey.list.theirEmptyState.title',
						)}
					</SectionTitle>
				</Box>
			</StyledFlex>
		</EmptyStateWrapper>
	);
}
